import { features } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            为什么选择51吃瓜官网
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            五大核心优势，打造全网最优质的吃瓜入口导航体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {features.map((feat, idx) => (
            <div
              key={feat.id}
              className="relative rounded-xl p-6 bg-background-50 border border-background-200/70 text-center hover:border-primary-200 transition-colors duration-200"
            >
              {idx === 0 && (
                <div className="absolute -top-1 right-3 px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-[10px] font-medium whitespace-nowrap">
                  核心
                </div>
              )}
              <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-primary-100 flex items-center justify-center">
                <i className={`${feat.icon} text-xl text-primary-500`}></i>
              </div>
              <h3 className="text-sm md:text-base font-medium text-foreground-800 mb-2">
                {feat.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                {feat.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}